import axios from 'axios';
import { constructServiceURL } from '../../../../utils/URLTools';

const apiFetchImpcStockLevelsListWithAlerts = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getImpcStockLevelsListWithAlerts',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, payload.params);
};

export default apiFetchImpcStockLevelsListWithAlerts;
